<template>
    <div >
        <FormMange 
            v-if="renderComponent === true"
            :tab="true" 
            :formProps="formProps"
            :startupIdProps="null"
            :batchData="batch"
            :demo="false"
            :isLockForm="null"/>
    </div>
</template>
<script>
import { HTTP,HTTPDynamic } from "../axios";
import FormMange from './form/FormMange'
export default {
    components:{
     FormMange
    },
  data() {
    return {
        formProps:{},
        renderComponent:false
    };
  },
  computed: {
    token() {
        return this.$store.state.token;
    },
    batch() {
      return this.$store.state.batch;
    },  
  },

  mounted() {
     this.fethFormBatch() 
  },
  methods: {
    async fethFormBatch(){
        
          let data ={
              batchId:this.batch._id
          }
            HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
            await HTTP.post(`get/form/on/batch`,data)
            .then(res => {
            //    console.log("get/form/on/batch", res);  
                if (res.data.success) {
                    if (res.data.obj.listComponents.length !== 0) {
                        if (res.data.obj.listComponents[0].componentId.type === 'template') {
                            this.fetchTmp(res.data.obj.listComponents[0].componentId.id)
                        }else{
                            this.fethForm(res.data.obj.listComponents[0].componentId.id)
                        }
                    }else{
                        this.formProps = {}
                        this.renderComponent = true
                    }
                }else{
                    this.formProps = {}
                    this.renderComponent = true
                }
                
            })
            .catch(e => {
                this.renderComponent = true
                console.log("get/form/on/batch/error",e);
            });
    },
    async fethForm(id){
        let arr = []
        arr[0]=id
          let data ={
              components:arr
          }
            HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
            await HTTPDynamic.post(`get/component/by/id`,data)
            .then(res => {
               // console.log("get/component/by/id", res);  
                if (res.data.success) {
                    if ((typeof res.data.obj.form[0] !== 'undefined')) {
                        let obj={
                            components:res.data.obj.form[0].components,
                            name: res.data.obj.form[0].name,
                            _id: res.data.obj.form[0]._id,
                            type:'component'
                        }
                        this.formProps = obj
                    }else{
                         this.formProps = {}
                    }
                }else{
                    this.formProps ={}
                }
                this.renderComponent = true
            })
            .catch(e => {
                this.renderComponent = true
                console.log("get/component/by/id/error",e);
            });
    },
    async fetchTmp(id){
        let data ={
            templateId:id
        }

        HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
        await HTTPDynamic.post(`get/template/by/id`,data)
        .then(res => {
           // console.log("get/template/by/id", res);  
            if (res.data.success) {
                this.formProps = (typeof res.data.obj !== 'undefined')?res.data.obj:{}
            }else{
                this.formProps = {}
            }
            this.renderComponent = true
        })
        .catch(e => {
            this.renderComponent = true
            console.log("get/template/by/id/error",e);
        });  

                   
    },
  },
};
</script>
<style scoped>

</style>
